import axios from "axios";
import { APIS } from "../utils/api-factory";
import {POST_HEADER} from '../../../../../utils/apiHeaders'


export const getOEMDetailsByMakeclass = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_OEM_DETAILS_BY_MAKE_CLASS, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateOEMDetails = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_OEM_DETAILS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateNpaWeightage = (data,callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios
        .post(APIS.SAVE_UPDATE_NPA_WEIGHTAGE,data, headerConfig)
        .then((res) => {
            callBack(res.data);
        })
        .catch((e) => {
            // error(e.res.data);
        });
};


export const getOEMBatteryDetails = (callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.get(APIS.GET_BATTERY_OEM_DETAILS, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}


export const SaveUpdateOEMBatteryDetails = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_BATTERY_ORM_DETAILS, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}

export const SaveUpdateOEMEvScorecard = (data, callBack, error) => {
  const headerConfig = {
    headers: {},
  };
  axios.post(APIS.SAVE_UPDATE_EVOEM_SCORECARD, data, headerConfig)
    .then(res => {
      callBack(res.data)
    })
    .catch(e => {
      // error(e.res.data)
    })
}